/* RESPONSIBLE TEAM: team-ai-agent */

import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class EcommerceTasksIndexController extends Controller {
  queryParams = ['title', 'state'];

  @tracked title: string | null = null;
  @tracked state: string | null = null;
}
